import { type PaymentMethod } from '../types';
import { NO_PAYMENT_METHOD_NEEDED } from './constants';

/**
 * Stripe SDK doesn't like 0 dollar totals so we don't attempt to confirm payments with that.
 * To be extra safe we are still passing in a payment method id in this scenario.
 */
export const fallbackNoPaymentIsNeeded = (paymentMethods: readonly PaymentMethod[]) => {
  return (
    fallbackToSavedPaymentMethod(paymentMethods) ?? {
      id: NO_PAYMENT_METHOD_NEEDED,
    }
  );
};

export const fallbackToSavedPaymentMethod = (paymentMethods: readonly PaymentMethod[]) => {
  const defaultPaymentMethod = paymentMethods.find((pm) => pm.isDefault);
  const firstPaymentMethod = paymentMethods[0];

  return defaultPaymentMethod ?? firstPaymentMethod;
};

/**
 * Stripe's description field includes "ending in" after the card type.
 */
export const removeEndingIn = (name?: string | null) => {
  if (!name) return '';

  return name.replaceAll('ending in ', '').replaceAll('ending in', '').trim();
};
